<template>
  <div>
    <b-modal v-model="openModal" :title="title" size="lg" @ok.prevent="attemptSubmit = true" @cancel="editing = false">

      <course-equivalent-form v-model="attemptSubmit" :terms="terms" :statuses="statuses"
        :workload-faculty="workloadFaculty" :item="editing ? selectedItem : null" v-on:complete="save"
        v-if="openModal"></course-equivalent-form>
    </b-modal>

    <b-modal v-model="confirmDeletion" title="Confirm Delete" v-if="selectedItem" @ok="remove(selectedItem)"
      @cancel="clear()">
      Are you sure you want to delete this course equivalent?
      <div>
        {{ selectedItem.notes }}
      </div>
    </b-modal>

    <table-widget :items="items" :perPage="perPage" :totalRows="totalRows" :current-page.sync="currentPage"
      :filter.sync="filter">
      <template slot="buttons">
        <b-button v-if="editable" @click="openModalAdd()" class="ml-2" variant="primary"><font-awesome-icon
            icon="plus" />Add Course Equivalent</b-button>
      </template>
      <template slot="content">
        <b-table striped :items="items" :fields="fields" :per-page="perPage" :current-page="currentPage" :filter="filter"
          @filtered="onFiltered" small show-empty :tbody-transition-props="transProps"
          empty-filtered-text="There are no course equivalents that match your search criteria.">
          <template v-slot:cell(createdDate)="data">
            {{ data.item.createdDate | formatDateTime }}
          </template>
          <template v-slot:cell(controls)="data">
            <div class="text-right" v-if="(data.item.status == 'Submitted') &&
              editable
              ">
              <font-awesome-icon icon="pencil-alt" class="edit-icon mx-1"
                @click="openModalEdit(data.item)"></font-awesome-icon>
              <font-awesome-icon icon="times" class="remove-icon mx-1"
                @click="confirmRemove(data.item)"></font-awesome-icon>
            </div>
          </template>
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import TableWidget from "../table-widget";
import CourseEquivalentForm from "./course-equivalent-form.vue";
import courseEquivalentsApi from "../../api/courseEquivalents";
import ToastrSettings from "../../settings/toastr-settings";
import toastr from "toastr";

import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      transProps: {
        // Transition name
        name: "fade"
      },
      items: [],
      fields: [
        { key: "status", sortable: true, label: "Status" },
        { key: "term", sortable: true, label: "Term" },
        { key: "numberOfCourses", sortable: true, label: "Number Of Courses" },
        { key: "reason", sortable: true, label: "Reason" },
        { key: "fullName", sortable: true, label: "Faculty" },
        { key: "createdDate", sortable: true, label: "Date" },
        { key: "controls", label: "" }
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      openModal: false,
      editing: false,
      selectedItem: null,
      attemptSubmit: false
    };
  },

  props: {
    courseEquivalents: {
      type: Array,
      required: true,
      default: function () {
        return [];
      }
    },
    editable: {
      type: Boolean,
      required: false,
      default: function () {
        return true;
      }
    },
    terms: {
      type: Array,
      required: true,
      default: function () {
        return [];
      }
    },
    workloadFaculty: {
      type: String,
      required: false
    }
  },

  components: { "table-widget": TableWidget, CourseEquivalentForm },

  computed: {
    title() {
      return this.editing ? "Edit Course Equivalent" : "Add Course Equivalent";
    }
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    init() {
      this.items = this.courseEquivalents;
      this.totalRows = this.items.length;
    },

    openModalAdd() {
      this.openModal = true;
      this.editing = false;
      this.selectedItem = null;
    },
    openModalEdit(item) {
      this.openModal = true;
      this.editing = true;
      this.selectedItem = item;
    },
    confirmRemove(item) {
      this.selectedItem = item;
      this.confirmDeletion = true;
    },
    remove(item) {
      courseEquivalentsApi.delete(item.id).then(() => {
        toastr.options = ToastrSettings;
        toastr.success("The course equivalent has been deleted.", "Success");
        this.$emit("refresh");
        this.confirmDeletion = false;
      });
    },
    clear() {
      this.selectedItem = null;
    },
    save(formData) {
      var courseEquivalent = formData.form;
      var files = formData.files;
      console.log("Saving course equivalent: ", courseEquivalent);
      if (courseEquivalent) {
        this.attemptSubmit = false;
        if (this.editing) {
          console.log("Editing course equivalent: ", courseEquivalent);
          courseEquivalentsApi
            .put(courseEquivalent.id, courseEquivalent)
            .then(() => {
              toastr.options = ToastrSettings;
              toastr.success("The request has been saved.", "Success");
              this.$emit("refresh");
              this.openModal = false;
              this.editing = false;
            });
        } else {
          // post the new course equivalent and then save the files
          courseEquivalentsApi.post(courseEquivalent).then(result => {
            if (files.length > 0) {
              courseEquivalentsApi.postFiles(result.data, files).then(() => {
                toastr.options = ToastrSettings;
                toastr.success("The request has been saved.", "Success");
                this.$emit("refresh");
                this.openModal = false;
                this.editing = false;
              });
            } else {
              toastr.options = ToastrSettings;
              toastr.success("The request has been saved.", "Success");
              this.$emit("refresh");
              this.openModal = false;
              this.editing = false;
            }
          });
        }
      }
    }
  },

  watch: {
    courseEquivalents: function () {
      this.init();
    }
  },

  created() {
    this.init();
    courseEquivalentsApi.getStatuses().then(response => {
      this.statuses = response.data;
    });
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
